module.exports = __webpack_public_path__ + "static/media/card-homeselect.31839cb7.png";